const doc = [({"da":({"js":({"models_table":({"columns_drop_down":({"columns":"Kolonner"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;